import { render, staticRenderFns } from "./studentForm.vue?vue&type=template&id=5759b871&"
import script from "./studentForm.vue?vue&type=script&lang=js&"
export * from "./studentForm.vue?vue&type=script&lang=js&"
import style0 from "./studentForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports